/** The accessibility modes, one tap each. The backend records the choice when the domain has the button. */
import { accessibilityModes } from '../../core/wire';
import { MODES } from '../../modes/modes';
import { useApp } from '../../react/app';
import { useMode, useSession, useTranslate, useUi } from '../../react/hooks';
import { Icon } from '../../ui-kit/Icon';
import { useUiActions } from '../useUiActions';
import css from './Overlays.module.css';

export function ModePicker() {
  const open = useUi((u) => u.modePickerOpen);
  const override = useUi((u) => u.modeOverride);
  const button = useApp().pack.accessibilityButton;
  const viaBackend = useSession((s) => (button ? s?.valid_actions.includes(button) ?? false : false));
  const mode = useMode();
  const t = useTranslate();
  const actions = useUiActions();
  if (!open) return null;
  return (
    <div className={css.backdrop} onClick={() => actions.toggleModePicker(false)}>
      <div className={css.sheet} role="dialog" aria-labelledby="mode-title" onClick={(e) => e.stopPropagation()}>
        <h2 id="mode-title" className={css.title}>{t('mode.title')}</h2>
        <div className={css.modes}>
          {accessibilityModes.map((id) => (
            <button key={id} className={`${css.mode} ${mode.id === id ? css.selected : ''}`} onClick={() => actions.setMode(id)}>
              <Icon name={MODES[id].icon} size={48} />
              <span>{t(MODES[id].label)}</span>
            </button>
          ))}
        </div>
        {(!viaBackend || override) && <p className={css.note}>{t('mode.local')}</p>}
      </div>
    </div>
  );
}
